module.exports = __webpack_public_path__ + "media/markers/marker-cluster-indigo-be477d33.svg";